import React from 'react';
import AdminListingPage from '../components/admin/AdminListingPage';

const AdminRentListings = () => {
  return (
    <AdminListingPage
      listingType="rent"
      heading="Rent / Lease"
      subtitle="Separate page for all rent and lease listings."
    />
  );
};

export default AdminRentListings;
